<!-- src/components/errorManagerComponent.vue -->
<template>
  <div v-if="flatErrors.length">
    <a-alert
      v-for="(msg, i) in flatErrors"
      :key="i"
      type="error"
      :message="msg"
      show-icon
      role="alert"
      class="error-item"
    />
  </div>
</template>

<script>
export default {
  name: 'ErrorManagerComponent',
  props: {
    // It can be a string, array of strings, or validation structures
    errors: {
      type: [Array, String, Object],
      required: true,
    },
  },
  computed: {
    flatErrors() {
      const out = []
      const src = this.errors

      const pushStr = (s) => {
        const txt = String(s ?? '').trim()
        if (txt) out.push(txt)
      }

      const fromObj = (o) => {
        if (o == null) return
        if (typeof o === 'string' || typeof o === 'number' || typeof o === 'boolean') {
          pushStr(o)
          return
        }
        if (Array.isArray(o)) {
          o.forEach(fromObj)
          return
        }
        if (typeof o === 'object') {
          // Typical formats: { message: '...' } | { message: ['...','...'] } | { constraints: {...} }
          if (Array.isArray(o.message)) o.message.forEach(fromObj)
          else if (typeof o.message === 'string') pushStr(o.message)

          if (o.constraints && typeof o.constraints === 'object') {
            Object.values(o.constraints).forEach(pushStr)
          }

          // fallback: extract loose strings
          Object.values(o).forEach((v) => {
            if (typeof v === 'string') pushStr(v)
            else if (Array.isArray(v)) v.forEach(fromObj)
          })
        }
      }

      fromObj(src)

      // If nothing came out, we put a message to avoid "empty card"
      if (!out.length) out.push('Ha ocurrido un error. Intenta de nuevo o verifica tu conexión.')

      return out
    },
  },
}
</script>

<style scoped>
.error-item {
  width: 100%;
  margin-bottom: 8px;
  text-align: left;
}
</style>
